import { BrowserAccessTokenStorage } from '~/ApiClient';

export function getAccessToken() {
	let accessToken: string | undefined;

	if (!accessToken) {
		const token = new BrowserAccessTokenStorage('access-token', {
			path: '/',
			httpOnly: false,
		});

		accessToken = token.loadToken() ?? undefined;
	}

	return accessToken;
}
